module.exports = __webpack_public_path__ + "img/sintomas podridão frutos início.0b327990.webp";